
import React from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Jessica Parker',
      age: 34,
      location: 'Los Angeles, CA',
      treatment: 'Energy Boost + Beauty Glow IV',
      quote: 'The combination of energy and beauty IVs has been incredible. My skin is glowing, my energy is through the roof, and I feel amazing. I get treatments weekly now!',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/2ee03bb7ce7e5c8ca481c96db0a8acb6.jpg'
    },
    {
      name: 'Marcus Johnson',
      age: 41,
      location: 'Atlanta, GA',
      treatment: 'Athletic Performance IV Series',
      quote: 'As a competitive athlete, IV therapy has revolutionized my recovery. I bounce back faster from intense training and my performance has reached new levels.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Athletic%20African%20American%20man%20in%20his%20forties%2C%20confident%20expression%2C%20sports%20attire%2C%20clean%20white%20background%2C%20professional%20headshot%20for%20sports%20medicine%20testimonial&width=300&height=300&seq=marcus-iv&orientation=squarish'
    },
    {
      name: 'Dr. Emily Chen',
      age: 39,
      location: 'San Francisco, CA',
      treatment: 'Brain Boost + Immune Support',
      quote: 'Working long hours as a surgeon, IV therapy keeps me sharp and healthy. The mental clarity and immune support have been game-changers for my demanding schedule.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20doctor%2C%20confident%20smile%2C%20medical%20scrubs%2C%20clean%20white%20background%2C%20professional%20headshot%20for%20medical%20wellness%20testimonial&width=300&height=300&seq=emily-iv&orientation=squarish'
    },
    {
      name: 'Robert Martinez',
      age: 55,
      location: 'Dallas, TX',
      treatment: 'Myers Cocktail + Detox IV',
      quote: 'After years of stress and poor health habits, IV therapy helped me turn things around. I have more energy than I\'ve had in decades and feel completely revitalized.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20middle-aged%20Hispanic%20businessman%2C%20warm%20smile%2C%20business%20suit%2C%20clean%20white%20background%2C%20professional%20headshot%20for%20executive%20wellness%20testimonial&width=300&height=300&seq=robert-iv&orientation=squarish'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Transformative Results with <strong>IV Therapy</strong>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Discover how our patients have enhanced their health, energy, and performance with our premium IV vitamin therapies.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg p-6 lg:p-8">
              <div className="flex items-start space-x-4 mb-6">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top"
                />
                <div className="flex-1">
                  <h4 className="font-bold text-gray-900 text-lg">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">Age {testimonial.age} • {testimonial.location}</p>
                  <p className="text-orange-600 text-sm font-medium mt-1">{testimonial.treatment}</p>
                </div>
                <div className="flex space-x-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
              </div>
              
              <blockquote className="text-gray-700 leading-relaxed italic">
                "{testimonial.quote}"
              </blockquote>
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 text-center">
          <div className="bg-orange-50 rounded-2xl p-6 lg:p-8 max-w-4xl mx-auto">
            <div className="grid sm:grid-cols-3 gap-6 lg:gap-8 mb-6">
              <div>
                <div className="text-2xl lg:text-3xl font-bold text-orange-600 mb-2">99%</div>
                <div className="text-gray-600">Patient Satisfaction</div>
              </div>
              <div>
                <div className="text-2xl lg:text-3xl font-bold text-orange-600 mb-2">5,000+</div>
                <div className="text-gray-600">IV Treatments Delivered</div>
              </div>
              <div>
                <div className="text-2xl lg:text-3xl font-bold text-orange-600 mb-2">15+</div>
                <div className="text-gray-600">Specialized Formulations</div>
              </div>
            </div>
            <button className="bg-gradient-to-r from-orange-600 to-orange-700 text-white px-8 py-4 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Start Your IV Journey
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
